import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Wallet model interface
export interface Wallet {
    id: number;
    customerId: number;
    currencyId: number;
    walletNo: string;
    name: string;
    status: boolean;
    statusDate: string;
    messageId: string | null;
    cDate: string;
    balance: number;
    iban: string;
}

// Main drawer state interface
interface InitialState {
    wallets: Wallet[];
}

const initialState: InitialState = {
    wallets: []
};

const walletsSlice = createSlice({
    name: 'wallets',
    initialState,
    reducers: {
        setGetWallet: (state, action: PayloadAction<Wallet[]>) => {
            state.wallets = action.payload;
        },
    },
});

export const { setGetWallet } = walletsSlice.actions;

export default walletsSlice.reducer;
